import { render, staticRenderFns } from "./RulebookCyclesTab.vue?vue&type=template&id=b97f6d4c&scoped=true&"
import script from "./RulebookCyclesTab.vue?vue&type=script&lang=js&"
export * from "./RulebookCyclesTab.vue?vue&type=script&lang=js&"
import style0 from "./RulebookCyclesTab.vue?vue&type=style&index=0&id=b97f6d4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97f6d4c",
  null
  
)

export default component.exports